<template>
  <v-row class="d-flex align-center">
    <v-col class="py-0" cols="3">
      <v-select
        v-model="item_selected"
        :items="items"
        :disabled="confirmed"
        :label="item_dropdown_label"
      />
    </v-col>
    <v-col
      class="py-0"
      cols="3"
    >
      <v-text-field
        v-model="value"
        hide-details
        :label="item_value_label"
        :value="value"
        :disabled="confirmed"
        outlined
        @keyup="trimChars"
      />
    </v-col>
    <v-col cols="1">
      <v-icon
        :disabled="items == '' || confirmed"
        color="primary"
        @click="addRow"
      >
        mdi-plus-box-outline
      </v-icon>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    id: {},
    items: {},
    item_dropdown_label: {
      default: '',
    },
    item_value_label: {
      default: '',
    },
  },
  data() {
    return {
      select: '',
      item_selected: '',
      value: 0,
    };
  },
  computed: {
    confirmed: {
      get() {
        return this.$store.getters.getSlideById(this.id).confirmed;
      },
    },
  },
  methods: {
    addRow() {
      this.value = this.value.replace(/[^0-9]/g, '');
      if (this.value == '') this.value = -1;

      this.$store.commit('addItem', {
        item: this.item_selected,
        value: parseInt(this.value),
        id: this.id,
      });
      this.$store.commit('updateIsDraft', true);
      this.item_selected = '';
      this.value = 0;
    },
    trimChars() {
      this.value = this.value.replace(/\D/, '');
    },
  },
};
</script>

<style></style>
